// 일본 지명
// 검색 0건 폴백 지명 사전의 jp 항목. 규약·운영 규칙은 ./index.ts 헤더 참고.
import type { SearchPlace } from "./index";

export const JP_PLACES: SearchPlace[] = [
  {
    id: "JP-TYO-IKEBUKURO",
    cityId: "JP-TYO",
    names: [
      "이케부쿠로", "ikebukuro", "池袋", "イケブクロ",
    ],
    coordinates: { latitude: 35.7295, longitude: 139.7109 },
  },
  {
    id: "JP-TYO-ROPPONGI",
    cityId: "JP-TYO",
    names: ["롯폰기", "roppongi", "六本木", "ロッポンギ"],
    coordinates: { latitude: 35.6641, longitude: 139.7294 },
  },
  {
    id: "JP-TYO-SHINBASHI",
    cityId: "JP-TYO",
    names: ["신바시", "shinbashi", "shimbashi", "新橋", "新桥"],
    coordinates: { latitude: 35.6663, longitude: 139.7583 },
  },
  {
    id: "JP-TYO-TOKYO-STATION",
    cityId: "JP-TYO",
    names: ["도쿄역", "동경역", "tokyo-station", "東京駅", "东京站", "東京站"],
    coordinates: { latitude: 35.6812, longitude: 139.7671 },
  },
  {
    id: "JP-TYO-NIHONBASHI",
    cityId: "JP-TYO",
    names: ["니혼바시", "nihonbashi", "日本橋", "日本桥"],
    coordinates: { latitude: 35.6838, longitude: 139.7745 },
  },
  {
    id: "JP-TYO-EBISU",
    cityId: "JP-TYO",
    names: ["에비스", "ebisu", "恵比寿", "惠比寿"],
    coordinates: { latitude: 35.6467, longitude: 139.7101 },
  },
  {
    id: "JP-TYO-NAKANO",
    cityId: "JP-TYO",
    names: ["나카노", "nakano", "中野", "ナカノ"],
    coordinates: { latitude: 35.7056, longitude: 139.6657 },
  },
  {
    id: "JP-TYO-KICHIJOJI",
    cityId: "JP-TYO",
    names: ["기치조지", "kichijoji", "吉祥寺", "キチジョウジ"],
    coordinates: { latitude: 35.703, longitude: 139.58 },
  },
  {
    id: "JP-TYO-HANEDA",
    cityId: "JP-TYO",
    names: [
      "하네다", "하네다공항", "haneda", "haneda-airport", "hnd",
      "羽田", "羽田空港", "羽田机场", "羽田機場",
    ],
    coordinates: { latitude: 35.5494, longitude: 139.7798 },
  },
  {
    id: "JP-OSA-TENNOJI",
    cityId: "JP-OSA",
    names: ["텐노지", "덴노지", "tennoji", "天王寺", "テンノウジ"],
    coordinates: { latitude: 34.6455, longitude: 135.5136 },
  },
  {
    id: "JP-OSA-SHINSEKAI",
    cityId: "JP-OSA",
    names: ["신세카이", "shinsekai", "新世界", "シンセカイ"],
    coordinates: { latitude: 34.6524, longitude: 135.5063 },
  },
  {
    id: "JP-OSA-KANSAI-AIRPORT",
    cityId: "JP-OSA",
    names: [
      "간사이공항", "관서공항", "kansai-airport", "kix",
      "関西空港", "関西国際空港", "关西机场", "關西機場",
    ],
    coordinates: { latitude: 34.432, longitude: 135.2304 },
  },
  {
    id: "JP-KYO-KYOTO-STATION",
    cityId: "JP-KYO",
    names: ["교토역", "kyoto-station", "京都駅", "京都站"],
    coordinates: { latitude: 34.9858, longitude: 135.7588 },
  },
  {
    id: "JP-KYO-NISHIKI",
    cityId: "JP-KYO",
    names: ["니시키", "니시키시장", "nishiki", "nishiki-market", "錦市場", "锦市场"],
    coordinates: { latitude: 35.005, longitude: 135.7649 },
  },
  {
    id: "JP-FUK-HAKATA",
    cityId: "JP-FUK",
    names: ["하카타", "hakata", "博多", "ハカタ"],
    coordinates: { latitude: 33.5898, longitude: 130.4207 },
  },
  {
    id: "JP-FUK-TENJIN",
    cityId: "JP-FUK",
    names: ["텐진", "덴진", "tenjin", "天神", "テンジン"],
    coordinates: { latitude: 33.5914, longitude: 130.3989 },
  },
  {
    id: "JP-FUK-AIRPORT",
    cityId: "JP-FUK",
    names: [
      "후쿠오카공항", "fukuoka-airport", "fuk",
      "福岡空港", "福冈机场", "福岡機場",
    ],
    coordinates: { latitude: 33.5859, longitude: 130.4507 },
  },
  {
    id: "JP-YOK-MINATOMIRAI",
    cityId: "JP-YOK",
    names: [
      "미나토미라이", "minatomirai", "minato-mirai",
      "みなとみらい", "港未来", "港未來",
    ],
    coordinates: { latitude: 35.4573, longitude: 139.6317 },
  },
  {
    id: "JP-YOK-CHUKAGAI",
    cityId: "JP-YOK",
    names: [
      "요코하마중화가", "chukagai", "yokohama-chinatown",
      "横浜中華街", "中華街", "中华街",
    ],
    coordinates: { latitude: 35.4437, longitude: 139.6455 },
  },
  {
    id: "JP-NAG-SAKAE",
    cityId: "JP-NAG",
    names: ["사카에", "sakae", "栄", "荣", "サカエ"],
    coordinates: { latitude: 35.1709, longitude: 136.9083 },
  },
  {
    id: "JP-NAG-NAGOYA-STATION",
    cityId: "JP-NAG",
    names: ["나고야역", "nagoya-station", "名古屋駅", "名古屋站"],
    coordinates: { latitude: 35.1706, longitude: 136.8816 },
  },
  {
    id: "JP-KOB-SANNOMIYA",
    cityId: "JP-KOB",
    names: ["산노미야", "sannomiya", "三宮", "三宫", "サンノミヤ"],
    coordinates: { latitude: 34.6947, longitude: 135.193 },
  },
  {
    id: "JP-KOB-HARBORLAND",
    cityId: "JP-KOB",
    names: ["하버랜드", "harborland", "harborland-kobe", "ハーバーランド"],
    coordinates: { latitude: 34.68, longitude: 135.179 },
  },
  {
    id: "JP-SPK-SUSUKINO",
    cityId: "JP-SPK",
    names: ["스스키노", "susukino", "すすきの", "薄野"],
    coordinates: { latitude: 43.0554, longitude: 141.353 },
  },
  {
    id: "JP-SPK-ODORI",
    cityId: "JP-SPK",
    names: ["오도리", "오도리공원", "odori", "odori-park", "大通", "大通公園"],
    coordinates: { latitude: 43.0606, longitude: 141.3565 },
  },
  {
    // 삿포로에서 ~43km. 홋카이도 관문 공항이라 삿포로 소속이 맞다.
    id: "JP-SPK-CHITOSE-AIRPORT",
    cityId: "JP-SPK",
    names: [
      "신치토세공항", "치토세공항", "chitose-airport", "cts",
      "新千歳空港", "新千岁机场", "新千歲機場",
    ],
    coordinates: { latitude: 42.7752, longitude: 141.6923 },
  },
  {
    id: "JP-PREF-HOKKAIDO",
    cityId: "JP-SPK",
    names: ["홋카이도", "hokkaido", "北海道", "hokkaido-prefecture"],
    coordinates: { latitude: 43.0642, longitude: 141.3469 },
  },
  {
    // 삿포로가 최근접 CITIES 도시 (254km)
    id: "JP-PREF-AOMORI",
    cityId: "JP-SPK",
    names: ["아오모리", "aomori", "青森県", "青森", "aomori-prefecture"],
    coordinates: { latitude: 40.8244, longitude: 140.74 },
  },
  {
    // 삿포로가 최근접 CITIES 도시 (374km)
    id: "JP-PREF-IWATE",
    cityId: "JP-SPK",
    names: ["이와테", "iwate", "岩手県", "岩手", "iwate-prefecture", "盛岡", "모리오카", "morioka"],
    coordinates: { latitude: 39.7036, longitude: 141.1527 },
  },
  {
    // 도쿄가 최근접 CITIES 도시 (304km)
    id: "JP-PREF-MIYAGI",
    cityId: "JP-TYO",
    names: ["미야기", "miyagi", "宮城県", "宮城", "miyagi-prefecture"],
    coordinates: { latitude: 38.2688, longitude: 140.8721 },
  },
  {
    // 삿포로가 최근접 CITIES 도시 (386km)
    id: "JP-PREF-AKITA",
    cityId: "JP-SPK",
    names: ["아키타", "akita", "秋田県", "秋田", "akita-prefecture"],
    coordinates: { latitude: 39.7186, longitude: 140.1024 },
  },
  {
    // 도쿄가 최근접 CITIES 도시 (289km)
    id: "JP-PREF-YAMAGATA",
    cityId: "JP-TYO",
    names: ["야마가타", "yamagata", "山形県", "山形", "yamagata-prefecture"],
    coordinates: { latitude: 38.2404, longitude: 140.3633 },
  },
  {
    // 도쿄가 최근접 CITIES 도시 (238km)
    id: "JP-PREF-FUKUSHIMA",
    cityId: "JP-TYO",
    names: ["후쿠시마", "fukushima", "福島県", "福島", "fukushima-prefecture"],
    coordinates: { latitude: 37.7503, longitude: 140.4676 },
  },
  {
    // 도쿄가 최근접 CITIES 도시 (96km)
    id: "JP-PREF-IBARAKI",
    cityId: "JP-TYO",
    names: ["이바라키", "ibaraki", "茨城県", "茨城", "ibaraki-prefecture", "水戸", "미토", "mito"],
    coordinates: { latitude: 36.3418, longitude: 140.4468 },
  },
  {
    // 도쿄가 최근접 CITIES 도시 (99km)
    id: "JP-PREF-TOCHIGI",
    cityId: "JP-TYO",
    names: ["도치기", "tochigi", "栃木県", "栃木", "tochigi-prefecture", "宇都宮", "우쓰노미야", "utsunomiya"],
    coordinates: { latitude: 36.5657, longitude: 139.8836 },
  },
  {
    // 도쿄가 최근접 CITIES 도시 (101km)
    id: "JP-PREF-GUNMA",
    cityId: "JP-TYO",
    names: ["군마", "gunma", "群馬県", "群馬", "gunma-prefecture", "前橋", "마에바시", "maebashi"],
    coordinates: { latitude: 36.3907, longitude: 139.0604 },
  },
  {
    // 도쿄가 최근접 CITIES 도시 (22km)
    id: "JP-PREF-SAITAMA",
    cityId: "JP-TYO",
    names: ["사이타마", "saitama", "埼玉県", "埼玉", "saitama-prefecture"],
    coordinates: { latitude: 35.857, longitude: 139.6489 },
  },
  {
    // 도쿄가 최근접 CITIES 도시 (33km)
    id: "JP-PREF-CHIBA",
    cityId: "JP-TYO",
    names: ["지바", "chiba", "千葉県", "千葉", "chiba-prefecture"],
    coordinates: { latitude: 35.6051, longitude: 140.1233 },
  },
  {
    id: "JP-PREF-TOKYO-TO",
    cityId: "JP-TYO",
    names: ["도쿄도", "tokyo-to", "東京都", "tokyo-to-prefecture"],
    coordinates: { latitude: 35.6895, longitude: 139.6917 },
  },
  {
    id: "JP-PREF-KANAGAWA",
    cityId: "JP-YOK",
    names: ["가나가와", "kanagawa", "神奈川県", "神奈川", "kanagawa-prefecture"],
    coordinates: { latitude: 35.4478, longitude: 139.6425 },
  },
  {
    // 도쿄가 최근접 CITIES 도시 (256km)
    id: "JP-PREF-NIIGATA",
    cityId: "JP-TYO",
    names: ["니가타", "niigata", "新潟県", "新潟", "niigata-prefecture"],
    coordinates: { latitude: 37.9026, longitude: 139.0232 },
  },
  {
    // 나고야가 최근접 CITIES 도시 (171km)
    id: "JP-PREF-TOYAMA",
    cityId: "JP-NAG",
    names: ["도야마", "toyama", "富山県", "富山", "toyama-prefecture"],
    coordinates: { latitude: 36.6953, longitude: 137.2113 },
  },
  {
    // 나고야가 최근접 CITIES 도시 (159km)
    id: "JP-PREF-ISHIKAWA",
    cityId: "JP-NAG",
    names: ["이시카와", "ishikawa", "石川県", "石川", "ishikawa-prefecture"],
    coordinates: { latitude: 36.5947, longitude: 136.6256 },
  },
  {
    // 나고야가 최근접 CITIES 도시 (116km)
    id: "JP-PREF-FUKUI",
    cityId: "JP-NAG",
    names: ["후쿠이", "fukui", "福井県", "福井", "fukui-prefecture"],
    coordinates: { latitude: 36.0652, longitude: 136.2216 },
  },
  {
    // 요코하마가 최근접 CITIES 도시 (100km)
    id: "JP-PREF-YAMANASHI",
    cityId: "JP-YOK",
    names: ["야마나시", "yamanashi", "山梨県", "山梨", "yamanashi-prefecture", "甲府", "고후", "kofu"],
    coordinates: { latitude: 35.6642, longitude: 138.5686 },
  },
  {
    // 도쿄가 최근접 CITIES 도시 (179km)
    id: "JP-PREF-NAGANO",
    cityId: "JP-TYO",
    names: ["나가노", "nagano", "長野県", "長野", "nagano-prefecture"],
    coordinates: { latitude: 36.6513, longitude: 138.181 },
  },
  {
    // 나고야가 최근접 CITIES 도시 (29km)
    id: "JP-PREF-GIFU",
    cityId: "JP-NAG",
    names: ["기후", "gifu", "岐阜県", "岐阜", "gifu-prefecture"],
    coordinates: { latitude: 35.3912, longitude: 136.7223 },
  },
  {
    // 요코하마가 최근접 CITIES 도시 (125km)
    id: "JP-PREF-SHIZUOKA",
    cityId: "JP-YOK",
    names: ["시즈오카", "shizuoka", "静岡県", "静岡", "shizuoka-prefecture"],
    coordinates: { latitude: 34.9769, longitude: 138.3831 },
  },
  {
    id: "JP-PREF-AICHI",
    cityId: "JP-NAG",
    names: ["아이치", "aichi", "愛知県", "愛知", "aichi-prefecture"],
    coordinates: { latitude: 35.1802, longitude: 136.9066 },
  },
  {
    // 나고야가 최근접 CITIES 도시 (62km)
    id: "JP-PREF-MIE",
    cityId: "JP-NAG",
    names: ["미에", "mie", "三重県", "三重", "mie-prefecture"],
    coordinates: { latitude: 34.7303, longitude: 136.5086 },
  },
  {
    // 교토가 최근접 CITIES 도시 (9km)
    id: "JP-PREF-SHIGA",
    cityId: "JP-KYO",
    names: ["시가", "shiga", "滋賀県", "滋賀", "shiga-prefecture", "大津", "오쓰", "otsu"],
    coordinates: { latitude: 35.0045, longitude: 135.8686 },
  },
  {
    id: "JP-PREF-KYOTO-FU",
    cityId: "JP-KYO",
    names: ["교토부", "kyoto-fu", "京都府", "kyoto-fu-prefecture"],
    coordinates: { latitude: 35.0212, longitude: 135.7556 },
  },
  {
    id: "JP-PREF-OSAKA-FU",
    cityId: "JP-OSA",
    names: ["오사카부", "osaka-fu", "大阪府", "osaka-fu-prefecture"],
    coordinates: { latitude: 34.6863, longitude: 135.52 },
  },
  {
    id: "JP-PREF-HYOGO",
    cityId: "JP-KOB",
    names: ["효고", "hyogo", "兵庫県", "兵庫", "hyogo-prefecture"],
    coordinates: { latitude: 34.6913, longitude: 135.183 },
  },
  {
    // 오사카가 최근접 CITIES 도시 (28km)
    id: "JP-PREF-NARA",
    cityId: "JP-OSA",
    names: ["나라", "nara", "奈良県", "奈良", "nara-prefecture"],
    coordinates: { latitude: 34.6851, longitude: 135.8048 },
  },
  {
    // 고베가 최근접 CITIES 도시 (52km)
    id: "JP-PREF-WAKAYAMA",
    cityId: "JP-KOB",
    names: ["와카야마", "wakayama", "和歌山県", "和歌山", "wakayama-prefecture"],
    coordinates: { latitude: 34.2261, longitude: 135.1675 },
  },
  {
    // 고베가 최근접 CITIES 도시 (126km)
    id: "JP-PREF-TOTTORI",
    cityId: "JP-KOB",
    names: ["돗토리", "tottori", "鳥取県", "鳥取", "tottori-prefecture"],
    coordinates: { latitude: 35.5039, longitude: 134.238 },
  },
  {
    // 고베가 최근접 CITIES 도시 (214km)
    id: "JP-PREF-SHIMANE",
    cityId: "JP-KOB",
    names: ["시마네", "shimane", "島根県", "島根", "shimane-prefecture", "松江", "마쓰에", "matsue"],
    coordinates: { latitude: 35.4723, longitude: 133.0505 },
  },
  {
    // 고베가 최근접 CITIES 도시 (115km)
    id: "JP-PREF-OKAYAMA",
    cityId: "JP-KOB",
    names: ["오카야마", "okayama", "岡山県", "岡山", "okayama-prefecture"],
    coordinates: { latitude: 34.6618, longitude: 133.935 },
  },
  {
    // 후쿠오카가 최근접 CITIES 도시 (210km)
    id: "JP-PREF-HIROSHIMA",
    cityId: "JP-FUK",
    names: ["히로시마", "hiroshima", "広島県", "広島", "hiroshima-prefecture"],
    coordinates: { latitude: 34.3963, longitude: 132.4596 },
  },
  {
    // 후쿠오카가 최근접 CITIES 도시 (119km)
    id: "JP-PREF-YAMAGUCHI",
    cityId: "JP-FUK",
    names: ["야마구치", "yamaguchi", "山口県", "山口", "yamaguchi-prefecture"],
    coordinates: { latitude: 34.1859, longitude: 131.4706 },
  },
  {
    // 고베가 최근접 CITIES 도시 (91km)
    id: "JP-PREF-TOKUSHIMA",
    cityId: "JP-KOB",
    names: ["도쿠시마", "tokushima", "徳島県", "徳島", "tokushima-prefecture"],
    coordinates: { latitude: 34.0658, longitude: 134.5593 },
  },
  {
    // 고베가 최근접 CITIES 도시 (113km)
    id: "JP-PREF-KAGAWA",
    cityId: "JP-KOB",
    names: ["가가와", "kagawa", "香川県", "香川", "kagawa-prefecture"],
    coordinates: { latitude: 34.3401, longitude: 134.0434 },
  },
  {
    // 후쿠오카가 최근접 CITIES 도시 (220km)
    id: "JP-PREF-EHIME",
    cityId: "JP-FUK",
    names: ["에히메", "ehime", "愛媛県", "愛媛", "ehime-prefecture"],
    coordinates: { latitude: 33.8416, longitude: 132.7657 },
  },
  {
    // 고베가 최근접 CITIES 도시 (198km)
    id: "JP-PREF-KOCHI",
    cityId: "JP-KOB",
    names: ["고치", "kochi", "高知県", "高知", "kochi-prefecture"],
    coordinates: { latitude: 33.5597, longitude: 133.5311 },
  },
  {
    id: "JP-PREF-FUKUOKA-KEN",
    cityId: "JP-FUK",
    names: ["후쿠오카현", "fukuoka-ken", "福岡県", "fukuoka-ken-prefecture"],
    coordinates: { latitude: 33.6064, longitude: 130.4181 },
  },
  {
    // 후쿠오카가 최근접 CITIES 도시 (39km)
    id: "JP-PREF-SAGA",
    cityId: "JP-FUK",
    names: ["사가", "saga", "佐賀県", "佐賀", "saga-prefecture"],
    coordinates: { latitude: 33.2494, longitude: 130.2988 },
  },
  {
    // 후쿠오카가 최근접 CITIES 도시 (106km)
    id: "JP-PREF-NAGASAKI",
    cityId: "JP-FUK",
    names: ["나가사키", "nagasaki", "長崎県", "長崎", "nagasaki-prefecture"],
    coordinates: { latitude: 32.7448, longitude: 129.8737 },
  },
  {
    // 후쿠오카가 최근접 CITIES 도시 (94km)
    id: "JP-PREF-KUMAMOTO",
    cityId: "JP-FUK",
    names: ["구마모토", "kumamoto", "熊本県", "熊本", "kumamoto-prefecture"],
    coordinates: { latitude: 32.7898, longitude: 130.7417 },
  },
  {
    // 후쿠오카가 최근접 CITIES 도시 (119km)
    id: "JP-PREF-OITA",
    cityId: "JP-FUK",
    names: ["오이타", "oita", "大分県", "大分", "oita-prefecture"],
    coordinates: { latitude: 33.2382, longitude: 131.6126 },
  },
  {
    // 후쿠오카가 최근접 CITIES 도시 (210km)
    id: "JP-PREF-MIYAZAKI",
    cityId: "JP-FUK",
    names: ["미야자키", "miyazaki", "宮崎県", "宮崎", "miyazaki-prefecture"],
    coordinates: { latitude: 31.9111, longitude: 131.4239 },
  },
  {
    // 후쿠오카가 최근접 CITIES 도시 (226km)
    id: "JP-PREF-KAGOSHIMA",
    cityId: "JP-FUK",
    names: ["가고시마", "kagoshima", "鹿児島県", "鹿児島", "kagoshima-prefecture"],
    coordinates: { latitude: 31.5602, longitude: 130.5581 },
  },
  {
    // 후쿠오카가 최근접 CITIES 도시 (861km)
    id: "JP-PREF-OKINAWA",
    cityId: "JP-FUK",
    names: ["오키나와", "okinawa", "沖縄県", "沖縄", "okinawa-prefecture"],
    coordinates: { latitude: 26.2124, longitude: 127.6809 },
  },
  {
    // 도쿄 최근접 (6km)
    id: "JP-SHINAGAWA",
    cityId: "JP-TYO",
    names: ["시나가와", "shinagawa", "品川"],
    coordinates: { latitude: 35.6285, longitude: 139.7387 },
  },
  {
    // 요코하마 최근접 (3km)
    id: "JP-YOKOHAMA-STATION",
    cityId: "JP-YOK",
    names: ["요코하마역", "yokohama-station", "横浜駅"],
    coordinates: { latitude: 35.4657, longitude: 139.6222 },
  },
  {
    // 후쿠오카 최근접 (80km)
    id: "JP-HUIS-TEN-BOSCH",
    cityId: "JP-SSB",
    names: ["하우스텐보스", "huis-ten-bosch", "ハウステンボス"],
    coordinates: { latitude: 33.0866, longitude: 129.7876 },
  },
  {
    // 오사카 최근접 (4km)
    id: "JP-SHIN-OSAKA",
    cityId: "JP-OSA",
    names: ["신오사카", "shin-osaka", "新大阪"],
    coordinates: { latitude: 34.7336, longitude: 135.5 },
  },
  {
    // 교토 최근접 (14km)
    id: "JP-UJI",
    cityId: "JP-KYO",
    names: ["우지", "uji", "宇治"],
    coordinates: { latitude: 34.8844, longitude: 135.7998 },
  },
  {
    // 도쿄 최근접 (12km)
    id: "JP-TOKYO-DISNEY",
    cityId: "JP-TYO",
    names: ["도쿄디즈니랜드", "tokyo-disneyland", "ディズニーランド", "디즈니랜드"],
    coordinates: { latitude: 35.6329, longitude: 139.8804 },
  },
];
